export interface ZoomLevelEntry {
  level: number;
  imageUrl: string;
}

export function mergeZoomLevel(
  levels: ZoomLevelEntry[],
  level: number,
  imageUrl: string | undefined | null,
): ZoomLevelEntry[] {
  if (!imageUrl) return levels;
  if (levels.some((z) => z.level === level)) return levels;
  return [...levels, { level, imageUrl }].sort((a, b) => a.level - b.level);
}

export function currentZoomImageUrl(
  levels: ZoomLevelEntry[],
  activeLevel: number,
  fallback?: string | null,
): string | undefined {
  return levels.find((z) => z.level === activeLevel)?.imageUrl
    ?? levels[levels.length - 1]?.imageUrl
    ?? fallback
    ?? undefined;
}
